import { useTrackView } from 'src/app/shared/hooks/tracking';

export function useTrackPageView(): void {
	useTrackView('starter_dashboard_index_view');
}
